import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, FormHelperText, Grid, Typography } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import { BankStatusOptions } from "app/containers/TreatmentBanks/types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  selectBanksLoading,
  selectBanksOptions,
} from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  departmentId: number;
  organizationId: number;
  xs?: number;
  changeValue: (value: number) => void;
  disabled?: boolean;
  showAll?: boolean;
  error?: string;
  showStatus?: boolean;
  includeStatus?: BankStatusOptions[];
  noReset?: boolean;
  isRequired?: boolean;
}

const statusSummary = {
  New: "(N)",
  Running: "(R)",
  Done: "(D)",
};
const BankFiled = (props: TProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectBanksOptions);
  const loading = useSelector(selectBanksLoading);

  const { t } = useTranslation();
  const showStatus = props.showStatus ?? true;
  useEffect(() => {
    if (props.showAll) {
      if (!props?.noReset) {
        props.changeValue(0);
      }
      dispatch(
        actions.getBankList({
          departmentId: props.departmentId,
          organizationId: props.organizationId,
          includeStatus: props.includeStatus || [],
        })
      );
      return;
    }
    if (props.departmentId > 0 && props.organizationId > 0 && !props.showAll) {
      dispatch(
        actions.getBankList({
          departmentId: props.departmentId,
          organizationId: props.organizationId,
          includeStatus: props.includeStatus || [],
        })
      );
      return;
    }
    dispatch(actions.getBankListSuccess([]));

    return () => {};
  }, [props.departmentId, props.organizationId, props.showAll, props?.noReset]);

  const hasError = !!props?.error;

  const options: SelectOption[] = List.map((item: any) => ({
    label: item.name,
    value: item.id,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("TIMESLOT.BANK_NAME")}
        {props.isRequired && <span style={{ color: "red" }}> *</span>}
        {Number(props.value) > 0 ? (
          <Link
            to={`/treatment-banks/treatment-bank-details/${props.value}/view`}
            target="_blank"
            style={{ textDecoration: "none" }}
            rel="noopener noreferrer"
          >
            <OpenInNewIcon fontSize="small" />
          </Link>
        ) : null}
      </label>
      <SearchableSelect
        options={options}
        value={props?.value?.toString() ?? ""}
        onChange={(val) => props.changeValue(Number(val))}
        disabled={props.disabled}
        loading={loading}
        searchable
        error={hasError}
        className={styles.textEnabled}
        showAllOption={
          props.showAll ? { label: t("COMMON.ALL"), value: 0 } : undefined
        }
        renderOption={(o) => (
          <Typography
            sx={{
              display: "flex",
              justifyContent: "space-between",
              whiteSpace: "nowrap",
              flex: 1,
              width: "100%",
            }}
          >
            <span
              style={{
                marginRight: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 8,
              }}
            >
              {" "}
              {o.label}
            </span>
            {showStatus && o.raw && (
              <span
                style={{
                  flex: 2,
                }}
              >
                {" "}
                {statusSummary[o.raw.bankStatus]}
              </span>
            )}
          </Typography>
        )}
      />
      <Box
        sx={{
          display: "flex",
        }}
      >
        {hasError && <FormHelperText error>{props?.error}</FormHelperText>}
      </Box>
    </Grid>
  );
};
export default React.memo(BankFiled);
